import { Template } from "typings/index";
import { ApiBase } from "./ApiBase";

export class TemplateAPI extends ApiBase
{
    fetchAll(): Promise<Template[]>
    {
        return this.get<Template[]>("template");
    }

    fetchOne(id: string): Promise<Template>
    {
        return this.get<Template>(`template/${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/template.ts